/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import clsx from 'clsx';
import {
    Box,
    Grid,
    Paper,
    TextField,
    Button,
    Typography,
    Avatar, InputAdornment, IconButton
} from '@mui/material';
import { Link } from "react-router-dom";
import customStyles from "../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/actions";
import logoImg from "../../../../assets/images/logo.png"
import changePasswordImg from "../../../../assets/images/change-password.png"
import { Image } from "antd";
import { toast } from 'react-toastify';
import { emptyValidation, customPasswordMatch, customPassword } from "../../../../helpers/validation";
import Visibility from "../../../Shared/components/Icons/Visibility";
import VisibilityOff from "../../../Shared/components/Icons/VisibilityOff";
import usePrevious from "../../../Shared/components/Previous";


const ChangePassword = (props) => {
    const { changePasswordDetails, changePasswordError, changePasswordLoader, verifyPasswordError } = useSelector(state => state.authReducer);
    const prevChangePasswordDetails = usePrevious(changePasswordDetails);
    const prevChangePasswordError = usePrevious(changePasswordError);
    const prevVerifyPasswordError = usePrevious(verifyPasswordError);

    const [oldPassword, setoldPassword] = useState('');
    const [newPassword, setnewPassword] = useState('');
    const [confirmPassword, setconfirmPassword] = useState('');

    const [errorOldPassword, setErroroldPassword] = useState(false);
    const [errorNewPassword, setErrornewPassword] = useState(false);
    const [errorConfirmPassword, setErrorconfirmPassword] = useState(false);
    const [passwordOldShown, setPasswordOldShown] = useState(false);

    const [passwordNewShown, setPasswordNewShown] = useState(false);
    const [passwordConfirmShown, setPasswordConfirmShown] = useState(false);

    const dispatch = useDispatch();

    const emptyAllState = () => {
        setErroroldPassword(false);
        setErrornewPassword(false);
        setErrorconfirmPassword(false);
    }

    const emptyAllStateInput = () => {
        setoldPassword('');
        setnewPassword('');
        setconfirmPassword('');
    }

    useEffect(() => {
        // emptyAllState();
        // checkLogin(props);
        // checkLoginPassword(props);
    }, []);

    useEffect(() => {
        if (prevChangePasswordDetails !== undefined && changePasswordDetails && prevChangePasswordDetails !== changePasswordDetails) {
            toast.dismiss();
            toast(changePasswordDetails.message);
            dispatch({
                type: actions.CLEAR_PASSWORD_START
            });
            emptyAllStateInput();
        } else if (prevChangePasswordError !== undefined && changePasswordError && prevChangePasswordError !== changePasswordError) {
            setErroroldPassword(changePasswordError?.error?.message);
        }
    }, [changePasswordDetails, changePasswordError]);

    useEffect(() => {
        if (prevVerifyPasswordError !== undefined && verifyPasswordError && prevVerifyPasswordError !== verifyPasswordError) {
            setErroroldPassword(verifyPasswordError.error.message);
        }
    }, [verifyPasswordError])

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyOldPassword = emptyValidation('Old Password', oldPassword);
        let emptyNewPassword = customPassword('New Password', newPassword);
        let emptyConfirmPassword = customPasswordMatch('Confirm Password', newPassword, confirmPassword);
        emptyAllState();
        if (emptyOldPassword.isValid && emptyNewPassword.isValid && emptyConfirmPassword.isValid) {
            dispatch({
                type: actions.CHANGE_PASSWORD_START,
                changePasswordData: {
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                    confirmPassword: confirmPassword
                }
            });
        } else {
            if (emptyOldPassword.errors !== '') {
                setErroroldPassword(emptyOldPassword.errors);
            } if (emptyNewPassword.errors !== '') {
                setErrornewPassword(emptyNewPassword.errors);
            } if (emptyConfirmPassword.errors !== '') {
                setErrorconfirmPassword(emptyConfirmPassword.errors);
            }
        }
    }

    const handleBlur = (e) => {
        e.preventDefault();
        let emptyOldPassword = emptyValidation('Old Password', oldPassword);
        emptyAllState();
        if (emptyOldPassword.isValid) {
            dispatch({
                type: actions.VERIFY_PASSWORD_START,
                verifyPasswordData: {
                    password: oldPassword,
                }
            });
        } else {
            if (emptyOldPassword.errors !== '') {
                setErroroldPassword(emptyOldPassword.errors);
            }
        }
    }

    const classes = customStyles();
    return (
        <div className={clsx(classes.backgroundWhite, classes.boxBorder1)}>
            <Paper className={clsx(classes.authContainer)} sx={{ p: 2 }}>
                <Grid container className={clsx(classes.authRoot, classes.fullHei)}>
                    <Link to="/login" className={clsx(classes.customLogoLink)}>
                        <Avatar
                            alt="Logo"
                            src={logoImg}
                            className={clsx(classes.customLogo)}
                            variant={'square'}
                        />
                    </Link>
                    <Grid xxl={7} xl={7} lg={7} md={7} sm={5} item className={classes.mobileDisplay}>
                        <Image
                            alt="Login"
                            preview={false}
                            src={changePasswordImg}
                            variant={'square'}
                        />
                    </Grid>
                    <Grid xxl={5} xl={5} lg={5} md={5} sm={7} xs={12} className={clsx(classes.cardSize, classes.loginForm)} item>
                        <Paper style={{ backgroundColor: 'transparent' }}>
                            <Grid align='center'>
                                <Typography variant="h6" className={clsx(classes.customTitle, classes.primaryFont, classes.bold)}>Change Password</Typography>
                            </Grid>
                            <Box
                                className={clsx(classes.removeUnderline)}
                                component="form"
                                autoComplete="off"
                                onSubmit={(e) => handleSubmit(e)}>
                                <TextField autoComplete='nope'
                                    label='Old Password'
                                    type={passwordOldShown ? "text" : "password"}
                                    fullWidth
                                    error={errorOldPassword && true}
                                    helperText={errorOldPassword}
                                    onBlur={(e) => handleBlur(e)}
                                    variant={'standard'}
                                    className={clsx(classes.margin40t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        },
                                        endAdornment: (
                                            <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordOldShown(!passwordOldShown)} position="end" >
                                                <IconButton tabIndex={-1}>
                                                    {passwordOldShown ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setoldPassword(e.target.value)}
                                />
                                <TextField autoComplete='nope'
                                    label='New Password'
                                    type={passwordNewShown ? "text" : "password"}
                                    fullWidth
                                    variant={'standard'}
                                    error={errorNewPassword && true}
                                    helperText={errorNewPassword}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        },
                                        endAdornment: (
                                            <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordNewShown(!passwordNewShown)} position="end" >
                                                <IconButton tabIndex={-1}>
                                                    {passwordNewShown ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setnewPassword(e.target.value)}
                                />
                                <TextField autoComplete='nope'
                                    label='Confirm Password'
                                    type={passwordConfirmShown ? "text" : "password"}
                                    fullWidth
                                    variant={'standard'}
                                    error={errorConfirmPassword && true}
                                    helperText={errorConfirmPassword}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        },
                                        endAdornment: (
                                            <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordConfirmShown(!passwordConfirmShown)} position="end" >
                                                <IconButton tabIndex={-1}>
                                                    {passwordConfirmShown ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setconfirmPassword(e.target.value)}
                                />
                                <Button
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    fullWidth
                                    className={clsx(classes.margin40t, classes.modalBtn, { [classes.loading]: changePasswordLoader })}
                                >
                                    Save New Password
                                </Button>
                                <div className={classes.loading}></div>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    )
}

export default ChangePassword